module.exports = __webpack_public_path__ + "img/minus-simple.5993440.svg";